import { Chip, formatPrice } from '@fagmobler/ui';
import {
  useCurrentRefinements,
  UseCurrentRefinementsProps,
} from 'react-instantsearch';
import { twMerge } from 'tailwind-merge';

type Props = {
  excludedAttributes: UseCurrentRefinementsProps['excludedAttributes'];
  limit?: number;
  onShowMore?: () => void;
  className?: string;
};

export function CurrentRefinements({
  excludedAttributes,
  limit = 0,
  onShowMore,
  className,
}: Props) {
  const { items } = useCurrentRefinements({
    excludedAttributes,
  });

  const limitItems = items.slice(0, limit > 0 ? limit : items.length);
  const hasShowMore = limitItems.length < items.length;

  return (
    <div className={twMerge('w-full flex flex-wrap gap-2', className)}>
      {limitItems.flatMap((item) => {
        return item.refinements.map((refinement) => {
          const value = refinement.value;
          let label = `${item.attribute}: ${value}`;

          if (item.attribute === 'storesWithStockOrDisplay') {
            label = 'Kun på lager i din butikk';
          }

          if (item.attribute === 'material') {
            label = `Stoff og material: ${value}`;
          }

          if (item.attribute === 'width') {
            label = `Bredde: ${value} cm`;
          }

          if (item.attribute === 'height') {
            label = `Høyde: ${value} cm`;
          }

          if (item.attribute === 'length') {
            label = `Lengde: ${value} cm`;
          }

          if (item.attribute === 'serie') {
            label = `Serie: ${value}`;
          }

          if (item.attribute === 'colour') {
            label = `Farge: ${value}`;
          }

          if (item.attribute === 'space') {
            label = `Plassbehov: ${value}`;
          }

          if (item.attribute === 'bedsize') {
            label = `Liggemål: ${value} cm`;
          }

          if (item.attribute === 'depth') {
            label = `Dybde: ${value} cm`;
          }

          if (item.attribute === 'tags') {
            const text = value.toString();
            label = `${text.charAt(0).toUpperCase()}${text.slice(1)}`;
          }

          if (item.attribute === 'articleGroups.lvl1') {
            label = `${value}`;
          }

          if (
            item.attribute === 'price' &&
            refinement.operator === '>=' &&
            refinement.value
          ) {
            const price = refinement.value;
            label = `Fra ${formatPrice(
              typeof price === 'string' ? parseInt(price) : price
            )} kr`;
          }
          if (
            item.attribute === 'price' &&
            refinement.operator === '<=' &&
            refinement.value
          ) {
            const price = refinement.value;
            label = `Til ${formatPrice(
              typeof price === 'string' ? parseInt(price) : price
            )} kr`;
          }
          return (
            <div key={refinement.value}>
              <Chip
                label={label}
                size="lg"
                variant="light"
                onClick={() => {
                  item.refine(refinement);
                }}
              />
            </div>
          );
        });
      })}
      {hasShowMore && (
        <button
          className="cap-link-sm font-bold underline mt-2 cursor-pointer"
          onClick={() => {
            if (onShowMore) {
              onShowMore();
            }
          }}
        >
          Vis flere valgte filtre
        </button>
      )}
    </div>
  );
}
